<i18n src="@/locales/models/delivery.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/service_provider/delivery/managing/show_process.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-4">
    <h1 class="page-title">
      <i class="fa-solid fa-truck"></i>
      <span class="space-icon"></span>
      {{ $t("labels.deliveries_title") }}
    </h1>

    <div class="mt-2 flex flex-col">
      <ag-grid-vue
        style="height: 620px"
        class="ag-theme-alpine"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef()"
        :rowData="deliveries"
      >
      </ag-grid-vue>
    </div>

    <table-paginator
      v-model="current_page"
      v-if="total_rows > rows_per_page"
      :total_rows="total_rows"
      :rows_per_page="rows_per_page"
    >
    </table-paginator>
  </div>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import { dateFilter } from "@/components/views/mixins/ag_grid_filters.js";
import Requester from "@/views/service_provider/requesters/delivery/managing/show_process.js";

import GoToLink from "@/components/views/layout/ag_grid/GoToLink.vue";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";

export default {
  name: "SPDeliveryManagingShowProcessOrders",
  components: { AgGridVue, TablePaginator },
  data() {
    return {
      deliveries: [],
      current_page: 1,
      total_rows: 0,
      rows_per_page: 12,
    };
  },
  props: {
    service_provider_id: { required: true },
    delivery_process_id: { required: true },
    delivery_attributes: {
      type: Array,
      default: () => [],
    }
  },

  created() {
    this.fetchDeliveries();
  },

  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t("model.delivery.week"),
          field: "week",
          filter: "agNumberColumnFilter",
          flex: 0.7,
        },
        {
          headerName: this.$t("model.delivery.delivery_code"),
          field: "delivery_code",
          flex: 1,
          cellRendererSelector: (params) => {
            return {
              component: GoToLink,
              params: {
                text: params.value,
                path_name: this.routeName("show_delivery"),
                params_path: {
                  service_provider_id: this.service_provider_id,
                  delivery_process_id: this.delivery_process_id,
                  id: params.data.id,
                },
              },
            };
          },
        },
        // {
        //   headerName: this.$t("model.delivery.delivery_type"),
        //   field: "delivery_type",
        //   flex: 1,
        // },
        {
          headerName: this.$t("model.delivery.started_at"),
          field: "started_at",
          flex: 1,
          valueFormatter: (params) =>
            this.dateFormatter(params.data.started_at),
          filter: "agDateColumnFilter",
          filterParams: dateFilter,
        },
        {
          headerName: this.$t("model.delivery.delivered_at"),
          field: "delivered_at",
          flex: 1,
          valueFormatter: (params) =>
            this.dateFormatter(params.data.delivered_at),
          filter: "agDateColumnFilter",
          filterParams: dateFilter,
        },
        {
          headerName: this.$t("model.delivery.delivery_employee"),
          field: "user.name",
          filter: true,
          flex: 1,
        },
        ...this.delivery_attributes.map(attr => ({
          headerName: attr.label,
          valueGetter: (params) => {
            return params.data.delivery_attribute_values?.find(
              (item) => item.delivery_process_attribute_id == attr.id
            )?.label_value || '';
          },
          filter: true,
          flex: 1,
        })),
      ];
    }
  },

  methods: {
    fetchDeliveries: async function () {
      let response = await Requester.fetchDeliveries(
        this.service_provider_id,
        this.delivery_process_id,
        this.current_page,
        this.rows_per_page,
      );
      this.total_rows = response.data.total_rows
      this.deliveries = response.data.records;
    },

    defaultColDef: function () {
      return {
        sortable: true,
        filter: true,
        floatingFilter: true,
      };
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.sizeToFit();
    },

    sizeToFit() {
      this.gridApi.sizeColumnsToFit({ defaultMinWidth: 150 });
    },

    goToNewItem: function () {
      this.$router.push({
        name: this.routeName("new_delivery"),
        params: {
          service_provider_id: this.service_provider_id,
          delivery_process_id: this.delivery_process_id,
        },
      });
    },
  },

  watch: {
    current_page: async function () {
      this.load_data = false;
      await this.fetchDeliveries();
      this.load_data = true;
    }
  }
};
</script>
